import React, { use, useState } from "react";
import { useForm } from "react-hook-form";
import {
    Box,
    Button,
    TextField,
    Typography,
    Paper,
    InputAdornment,
    Alert,
    Link,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import Api from "../services/apis/setup";
import { useNavigate, Link as RouterLink } from "react-router-dom";

export default function LoginForm() {
    const {
        register,
        handleSubmit,
        formState: { errors, isSubmitting },
    } = useForm();
    const [signIn] = Api.useSignInMutation();
    const navigate = useNavigate();
     // 👇 Track API error
  const [apiError, setApiError] = useState<string | null>(null);

    const onSubmit = async (data: any) => {

    const response = await signIn({
        baseURL: "/auth/login",
        payload: JSON.stringify({
            email: data.email,
            password: data.password,
        }),
        arguments: {
            email: data.email,
            password: data.password,
        },
    });
    if (response?.data?.success) {
        navigate("/");
    } else {
        // 👇 Show error message
        setApiError(response?.data?.message || "Login failed");
    }
    };

    return (
        <Box>
            <Typography variant="h5" align="center" gutterBottom>
                Login
            </Typography>

            <Box
                component="form"
                onSubmit={handleSubmit(onSubmit)}
                sx={{ display: "flex", flexDirection: "column", gap: 2 }}
            >
                {/* API Error */}
                {apiError && <Alert severity="error">{apiError}</Alert>}

                {/* Email */}
                <TextField
                    label="Email"
                    type="email"
                    fullWidth
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <EmailIcon />
                            </InputAdornment>
                        ),
                    }}
                    {...register("email", {
                        required: "Email is required",
                        pattern: {
                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            message: "Enter a valid email address",
                        },
                    })}
                    error={!!errors.email}
                    helperText={<>{errors.email?.message}</>}
                />

                {/* Password */}
                <TextField
                    label="Password"
                    type="password"
                    fullWidth
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <LockIcon />
                            </InputAdornment>
                        ),
                    }}
                    {...register("password", {
                        required: "Password is required",
                        minLength: {
                            value: 6,
                            message: "Password must be at least 6 characters",
                        },
                    })}
                    error={!!errors.password}
                    helperText={<>{errors.password?.message}</>}
                />

                <Button
                    type="submit"
                    variant="contained"
                    disabled={isSubmitting}
                    sx={{ backgroundColor: 'var(--primary-color)' }}
                >
                    {isSubmitting ? "Logging in..." : "Login"}
                </Button>

                <Box sx={{ textAlign: 'center' }}>
                    <Link
                        component={RouterLink}
                        to="/forgot-password"
                        variant="body2"
                        sx={{ color: 'var(--primary-color)', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}
                    >
                        Forgot Password?
                    </Link>
                </Box>
            </Box>
        </Box>
    );
}